import { Text } from '@yes.technology/react-toolkit'
import { Array, Number, Optional, Record, String, Unknown } from 'runtypes'
import { StyleMap } from 'site/Renderer/hooks/useStyleMap'

export type TextSliderObject = {
  uuid?: string
  des: string
  obs: string
  complement?: string
  headerVariant?: TextVariant
  headerColor?: string
  descriptionVariant?: TextVariant
  descriptionColor?: string
  contentVariant?: TextVariant
  contentColor?: string
}

type TextVariant = React.ComponentProps<typeof Text>['variant']

export type TextSliderProps = {
  props: {
    objects: TextSliderObject[]
    color?: string
    initial_slider?: number
    right_arrow_color?: string
    left_arrow_color?: string
    header_variant?: TextVariant
    header_color?: string
    description_variant?: TextVariant
    description_color?: string
    content_variant?: TextVariant
    content_color?: string
    styleMap?: StyleMap
  } & React.HTMLAttributes<HTMLDivElement>
}

export const TextSliderTypeGuard = Record({
  objects: Array(
    Record({
      uuid: Optional(String),
      obs: String,
      des: String,
      complement: Optional(String)
    })
  ),
  color: Optional(String),
  right_arrow_color: Optional(String),
  left_arrow_color: Optional(String),
  initial_slider: Optional(Number),
  header_variant: Optional(String),
  header_color: Optional(String),
  description_variant: Optional(String),
  description_color: Optional(String),
  content_variant: Optional(String),
  content_color: Optional(String),
  styleMap: Optional(Unknown)
})
